<template>
  <div class="customer-detail-view">
    <title-component
      :size="1"
      :lineSeparator="'under'">
      <translate>Customer detail view</translate>
      <action-dropdown-component :actions="actions"></action-dropdown-component>
    </title-component>
    <!-- Customer details -->
    <grid-details-component
      v-if="customer.id"
      :display_spec="customerProfileSpecs"
      :item="customer"
      :item_keys="customer_keys">
    </grid-details-component>
    <!-- Messages -->
    <message-component v-if="customer.invoiceInformationMismatch" :level="'warning'">
      <translate> Customers invoice information has changed. Please review the new information before sending any new invoices. </translate>
    </message-component>
    <!-- Tabs -->
    <tabs-router-component :tabs="routes">
    </tabs-router-component>
    <!-- Popup for sending SMS reminder -->
    <card-modal-component
      :show="show_modal"
      @deactivate="toggleModal()"
      transition="fade"
      ref="send_sms_modal"
      :options="{hasOkBtn: { text: 'Send' }, hasCancelBtn: { enabled: true }}"
      @handleOk="sendSms($event)"
      @handleCancel="toggleModal()"
      :title="`Send SMS reminder`">
      <form-component
        slot="card-content"
        v-for="formDescriptor in formDescriptors"
        :formDescriptor="formDescriptor"
        :formData="getFormDataForDescriptor(formDescriptor)"
        :key="formDescriptor.id">
      </form-component>
    </card-modal-component>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { customerProfileSpecs, defaultCustomerKeys } from '@/display_context/display_context'
  import TitleComponent from '@/components/layout/TitleComponent'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent'
  import TabsRouterComponent from '@/components/layout/tabs/TabsRouterComponent.vue'
  import ActionDropdownComponent from '@/components/layout/utility/ActionDropdownComponent'
  import { setContainedHeightMixin, itemRefresher, switchToCustomerMixin, formHandlerMixin } from '@/mixins/mixins'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import { globalEventBus } from '@/utility/utility_functions'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'
  import FormComponent from '@/components/form/FormComponent'

  export default {
    name: 'customer-detail-view',
    mixins: [formHandlerMixin, setContainedHeightMixin, itemRefresher, switchToCustomerMixin],
    components: {
      ActionDropdownComponent,
      TitleComponent,
      GridDetailsComponent,
      TabsRouterComponent,
      MessageComponent,
      FormComponent,
      CardModalComponent
    },
    data () {
      return {
        customer_keys: defaultCustomerKeys,
        actions: [],
        customerProfileSpecs: customerProfileSpecs,
        routes: [
          {
            route: { name: 'InvoicingView' },
            text: 'Invoicing'
          },
          {
            route: { name: 'DocumentsView' },
            text: 'Documents'
          },
          {
            route: { name: 'CustomerCasesView' },
            text: 'Cases'
          },
          {
            route: { name: 'CustomerCertificatesView' },
            text: 'Certificates'
          },
          {
            route: { name: 'SmsLogView' },
            text: 'SMS log'
          },
          {
            route: { name: 'CustomerLogView' },
            text: 'Email Logs'
          },
          {
            route: { name: 'CustomerCardOrdersView' },
            text: 'Card orders'
          }
        ],
        customer: {},
        show_modal: false,
        setAction: this.setCustomer,
        switchToPath: '/profile'
      }
    },
    props: {
      customerId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        customers: state => state.customerModule.customers,
        formDescriptors: state => state.customerModule.sendSmsFormDescriptor,
        formDatas: state => state.customerModule.sendSmsFormData
      })
    },
    methods: {
      ...mapActions([
        'setupSendSmsForm',
        'saveSendSmsForm',
        'setCustomer',
        'clearCases',
        'successMessage'
      ]),
      toggleModal () {
        this.show_modal = !this.show_modal
      },
      setActions () {
        let customerId = this.customer.userId
        this.actions = []
        this.actions.push({
          type: 'ACTION',
          func: () => {
            this.$_switchToCustomerMixin_switch(customerId, this.switchToPath)
          },
          text: `Switch profile`
        })
        if (this.customer.isConnectedToInvoiceCustomer) {
          this.actions.push({
            type: 'ROUTE',
            route: { name: 'CustomerCreateInvoiceView', params: { customerId: this.customerId } },
            text: 'Create invoice...'
          })
        }
        this.actions.push({
          type: 'ACTION',
          func: () => {
            this.setupSendSmsAction()
          },
          text: `Send SMS`
        })
      },
      createRequestData (formDatas) {
        return {
          customerId: this.customerId,
          formDatas: formDatas,
          submitRequest: null
        }
      },
      switchCustomerKeys () {
        if (this.customer.hasAdditionalCommunes) {
          if (!this.customer_keys.includes('communes')) {
            this.customer_keys.push('communes')
          }
        }
      },
      setupSendSmsAction () {
        this.setupSendSmsForm(this.customerId).then((response) => {
          this.toggleModal()
        }).catch((err) => {
          this.handleError(err)
        })
      },
      sendSms (btn) {
        let requestData = this.createRequestData(this.formDatas)
        this.submitRequest = this.saveSendSmsForm
        this.submitForm(requestData, btn, this.sendSmsCallback)
      },
      sendSmsCallback (response) {
        this.show_modal = false
        this.successMessage('SMS reminder sent successfully.')
        this.$refs.send_sms_modal.closeModal().then(() => {
          let callbacks = [this.setActions, this.switchCustomerKeys]
          this.setOrRefreshItem('customer', this.customers, this.customerId, callbacks)
        })
      }
    },
    created () {
      let callbacks = [this.setActions, this.switchCustomerKeys]
      this.setOrRefreshItem('customer', this.customers, this.customerId, callbacks)
      globalEventBus.$on('setActions', this.setActions)
      this.clearCases()
    },
    beforeDestroy () {
      globalEventBus.$off('setActions', this.setActions)
    }
  }
</script>
